<template>
  <div>
    <el-card>
      <nav class="out">
        <nav class="input">
          <el-input v-model="form.keyword" size="medium" placeholder="请输入国家代码或国家名称" />
        </nav>
        <nav class="input" style="width: 300px">
          <el-button size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="subimt">{{ "搜索" }}</el-button>
        </nav>
      </nav>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-table
          :data="list"
          style="width: 100%"
          border
          stripe
          :header-cell-style="rowClass"
          @sort-change="sortChange"
      >
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="code" label="国家代码" />
        <el-table-column prop="name" label="国家名称" />
        <el-table-column prop="isHot" label="是否热门" >
          <template slot-scope="ew">
           <el-tag v-if="ew.row.isHot==1" type="warning">
热门
           </el-tag>
            <el-tag v-else >
              非热门
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="是否隐藏" >
          <template slot-scope="ew">
            <el-tag class="red" v-if="ew.row.status==1" type="warning">
              隐藏
            </el-tag>
            <el-tag v-else >
              未隐藏
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderNum" label="排序值" >
          <template #header>
            <span>排序</span>
            <span style="font-size: 12px"><br />（当前最大值：{{ orderMax }}）</span>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">数值越大，显示越靠前</div>
              <i class="el-icon-warning-outline" style="margin-left: 5px" />
            </el-tooltip>
          </template>
          <template slot-scope="{ row }">
            <Remark
                :row="row"
                :val="{
                                url: '/admin/EnterpriseBusinessArea/editSort',
                                pw: 'enterprise_hot',
                            }"
                @getlist="getlist"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="ew">
            <el-button
                v-show="$store.state.btn_if.indexOf('enterprise_hot') != -1"
                type="text"
                icon="el-icon-s-flag"
                size="mini"
                class="skyblue"
                @click="edit(1,ew.row)"
            >{{ ew.row.isHot?'取消热门':'热门'}}</el-button
            >
            <el-button
                v-show="$store.state.btn_if.indexOf('enterprise_status') != -1"
                type="text"
                icon="el-icon-warning"
                size="mini"
                class="red"
                @click="edit(2,ew.row)"
            >{{  ew.row.status?'取消隐藏':'隐藏' }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="currentPage"
          background
          :page-sizes="[3, 5, 10, 15]"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </el-card>
    <el-dialog title="信息" :visible.sync="showinfo" width="40%" @close="">
      <el-form ref="form" :model="form_show" label-width="80px" :inline="false" size="normal">
        <el-form-item label="手机号">
          <el-input v-model="form_show.phone" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form_show.email" />
        </el-form-item>
      </el-form>
    </el-dialog>
    <chagne ref="chageref" @getlist="getlist" />
    <Drawers ref="drawer" :title="'采集工商信息'"></Drawers>
    <abbreviated-library ref="abbreviated"></abbreviated-library>
    <abbreviated-library ref="developer" type="developer"></abbreviated-library>
    <pass ref="pass" :dialog-visible.sync="p_a" :row="p_a_f" @getlist="getlist" />
    <exhibitor ref="exhibitor" @getlist="getlist"></exhibitor>
  </div>
</template>

<script>
import Remark from "@/components/remark/orderNum.vue";

let that;
import $ from "jquery";
import show from "../../components/countDowns/show.vue";
// import mixins from '../../mixin/getdiction'
import pass from "./enterprise_cert_list/pass.vue";
import remark from "../../components/remark/orderNum.vue";
import abbreviatedLibrary from "./enterprise_list/abbreviatedLibrary.vue";
import exhibitor from "./exhibitor.vue";
import fuzzySelection from "/src/components/fuzzySelection";
export default {
  provide() {
    return {
      getlist: this.getlist,

    };
  },
  components: {
    Remark,
    Show: show,
    RemarkOrder: remark,
    chagne: () => import("./enterprise_change.vue"),
    pass,
    abbreviatedLibrary,
    exhibitor,
    fuzzySelection,
  },
  data() {
    return {
      cityList: [],
      provinceId: "",
      cityId: "",
      city: "",
      province: "",
      dioA: false,
      showinfo: false,
      date: [],
      title: "",
      p_a: false,
      p_a_f: {},
      year: "",
      publishStatus: "",
      reportArea: "",
      reportBusiness: "",
      order: "",
      confing: "",
      btn: true,
      action: {
        action: "enterprise",
      },
      dioaddkuai: false,
      currentPage: 1,
      pagesize: 10,
      list: [],
      pai: [],
      paiform: {},
      value: "",
      dialogVisible: false,
      dialogVisiblexui: false,
      baseurl: this.$store.state.env.cdnImg,
      yu: "/" + this.$store.state.env.domain,
      total: 0,
      proof: false,
      form: {
        keyword:'',
        page: 1,
        pageSize: 10,

      },
      form_1: {
        id: "",
        title: "",
        source: "",
        picture: "",
        content: "",
        desc: "",
        areaCode: "",
        banner: "",
        viewType: "",
        businessId: "",
      },
      form_2: {

        name: "",
        isHide: "",
        type: "",
        business: "",
        subBusiness: "",
        serverArea: "",
        createDate: [],
        people: "",
        financing: "",
        top: "",
        egId: "",
        certCreateDate: [],
        activityId: "",
        isComplete:''
        // order: ''
      },
      form_3: {
        phone: this.$cookies.get("phone"),
      },
      s_form: {
        page: 1,
        pageSize: 10,
        name: "",
        isHide: "",
        type: "",
        business: "",
        subBusiness: "",
        serverArea: "",
        createDate: [],
        people: "",
        financing: "",
        top: "",
        egId: "",
        certCreateDate: [],
        activityId: "",
      },
      imageUrl: "",
      imageUrl_1: "",
      header: {
        Token: sessionStorage.getItem("token"),
      },
      form_show: {},
      area: [],
      orderMax: 0,
      typeList: [],
      businessList: [],
      subBusinessList: [],
    };
  },
  watch: {
    provinceId(val) {
      this.findCity(val);
    },
    "form_2.type"(newValue, oldValue) {
      this.form_2.business = "";
      this.form_2.subBusiness = "";
      this.getType("1");
    },
    "form_2.business"(newValue, oldValue) {
      this.form_2.subBusiness = "";
      this.getType("2");
    },
  },
  // mixins: [mixins],
  beforeCreate() {
    that = this;
  },
  updated() {
    //   console.log(this.form);
  },

  created() {
    // this.getconfig()
    // this.getconfig('user')
    this.getear();
    this.getlist();
    sessionStorage.setItem("action", "enterprise");
  },
  mounted() {
    // console.log(rules.req('撒打算'))
    this.getType();
    // this.$refs.chageRef.dialogVisible=true
    // console.log(this.confing_d)
  },
  methods: {
    async handleExport(){
      const { data: res } = await this.$http.get("admin/Enterprise/exportEnterprise", {
        params:{
          ...this.form_2,
          province: this.provinceId,
          city: this.cityId,
          createDate: this.form_2.createDate.join("~"),
          certCreateDate: this.form_2.certCreateDate.join("~"),
        }
      })
      if(res.data.url){
        const link = document.createElement("a");
        link.href = res.data.url;
        // link.target = "_blank";
        link.click();
        link.remove();
        this.$message.success(res.message);
      }else {
        this.$message.success('暂无数据，请调整筛选条件后继续导出。');
      }

    },
    async handleInputBlur(row) {
      this.paiform= {...row}
    },
    handleRemove(e){
      this.paiform.labelIds.filter(item=>item!=e)
      this.visibleChange()
    },
    /**
     * 下拉框
     * @param row
     * @returns {Promise<void>}
     */
    visibleChange(e){
      if(e){
        return
      }else {
        const  post=async (type)=>{
          const { data: res } = await this.$http.post("/admin/Enterprise/editEnterpriseLabel", {id:this.paiform.id,
            labelIds:this.paiform.labelIds.join(',')
          });
          if (res.errorCode == 200) {
            this.$message.success(res.message);
            //  row.pai=false
            //  this.tableData=[...this.tableData]
            this.getlist()
          }
        }
        post()

      }
    },
    op() {
      this.getc();
      this.editform.city = "";
    },
    // 省市
    async findCity(val) {
      if (!val) {
        return;
      }
      let { data: res } = await this.$http.get("/admin/Area/getList?code=" + val);
      console.log(res.data);
      this.cityList = res.data;
      this.cityId = "";
      // console.log(this.cityList)
    },
    getear() {
      this.$http.get("/admin/Area/getList").then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.province = res.data;
          // console.log(this.province,'//////');
          // console.log(this.editform.province)
        }
      });
    },
    getc() {
      this.$http.get("/admin/Area/getList?code=" + this.editform.province).then(({ data: res }) => {
        if (res.errorCode == 200) {
          console.log(this.editform.province);
          console.log(res);
          this.city = res.data;
        }
      });
    },
    edit_man(val) {
      this.$refs.chageref.dialogVisible = true;
      console.log(val.id);
      this.$refs.chageref.form.id = val.id;
    },
    accessToBusinessInformation(row) {
      this.$router.push({
        path: "/industrialIn_iformation_edit",
        query: {
          id: row.id,
        },
      });
    },
    reset() {
      Object.assign(this.form, this.$options.data.call(this).form);
      this.s_form = { ...this.form };
      this.getlist();
    },
    subimt() {
      this.currentPage = 1;
      this.form.page = 1;
      this.s_form = { ...this.form };

      this.getlist();
    },
    check() {
      console.log(1);
    },
    information(row) {
      this.showinfo = true;
      // this.form_show = row
      this.$http.get("/admin/UserSpeaker/getById", { params: { id: row.id } }).then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.form_show = res.data;
        }
      });
    },
    editorialActivityExhibitor(row) {
      this.$refs.exhibitor.init(row);
    },
    datum(row) {
      location.href = this.baseurl + this.yu + row.document;
    },
    sortChange(c) {
      console.log(c);
      if (c.order) {
        var s = "activity_" + c.prop;
        if (c.prop == "orderNum") {
          s = "report_order_num";
        } else if (c.prop == "views") {
          s = "report_views";
        } else {
          s = "report_" + c.prop;
        }
        var p = c.order.slice(0, c.order.length - 6);
        this.order = s + " " + p;
      } else {
        this.order = "";
      }

      this.getlist();
    },
    showinput(row) {
      row.pai = true;
      this.list = [...this.list];
      setTimeout(() => {
        $(".id input").focus();
      }, 20);
    },
    addkuai() {
      this.addkuai = false;
    },
    getea() {
      this.$http.get("/admin/ReportCategory/getList").then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.area = res.data;
        }
      });
    },
    rowClass() {
      return "background:#F5F7FA;";
    },
    handleSizeChange(e) {
      this.pagesize = e;
      console.log(e);
    },
    handleCurrentChange(e) {
      // this.getlist()
      this.s_form.page = e;
      this.form_2.page = e;

      this.getlist(this.s_form);
    },
    getlist(val) {
      var form = val || this.form;
      this.$http
          .get("/admin/EnterpriseBusinessArea/getList", {
            params: {
              ...form,
            },
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              // console.log(res)
              this.list = res.data.list;

              // console.log(this.list)
              this.total = res.data.totalCount;
              this.orderMax = res.data.orderMax;
            }
          });
    },
    checkf(val) {
      this.form_3 = val;
      // console.log(this.form_3)
    },
    async beforedown() {
      const phone = this.$cookies.get("phone");
      if (!phone) {
        this.$message.error("没有绑定手机号");
        return;
      }
      if (!this.proof) {
        this.dioA = true;
      } else {
        this.download();
      }
    },
    async download() {
      if (this.btn) {
        this.btn = false;

        if (false) {
          // this.$message.error(res.message)
          // return
        } else {
          const { data: res } = await this.$http.get("/admin/UserSpeaker/exportExcel", {
            params: {
              ...this.form_2,
              ...this.form_3,
            },
          });
          this.proof = true;
          this.btn = true;
          if (res.errorCode == 200) {
            this.$message.success(res.message);
            location.href = res.data.url;
            this.dioA = false;
          }
        }
      }
    },
    add() {},
    handleAvatarSuccess(res, file) {
      if (res.errorCode == 200) {
        this.form.banner = res.data.url;
      }
      //   console.log(file)
      //   console.log(imgurlbase)
    },
    async getType(val) {
      if (val == 1) {
        var { data: res } = await this.$http.get(
            `/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&typeId=${this.form_2.type}&businessId=`
        );
        this.businessList = res.data.list;
        return;
      }
      if (val == 2) {
        var { data: res } = await this.$http.get(
            `/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&typeId=${this.form_2.type}&businessId=${this.form_2.business}`
        );
        this.subBusinessList = res.data.list;
        return;
      }
      var { data: res } = await this.$http.get(
          "/admin/EnterpriseCategory/getList?keyword=&page=1&pageSize=100&order=&typeId=0&businessId="
      );
      this.typeList = res.data.list;
    },

    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === 'image/jpeg'
    //   const isLt2M = file.size / 1024 / 1024 < 2

    //   if (!isJPG) {
    //     this.$message.error('上传头像图片只能是 JPG 格式!')
    //   }
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 2MB!')
    //   }
    //   return isJPG && isLt2M
    // },
    handleAvatarSuccess_1(res, file) {
      if (res.errorCode == 200) {
        this.form_1.banner = res.data.url;
      }
      console.log(file);
      //   console.log(imgurlbase)
    },
    beforeAvatarUpload_1(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    addedit() {
      if (this.btn) {
        // this.form.picture = this.form.picture.slice(this.baseurl.length)

        this.$http.post("/admin/News/edit", this.form_1).then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.dialogVisiblexui = false;
            this.$message.success(res.message);
            this.getlist();
          }
          this.btn = true;
        });
      }
      this.btn = false;
    },
    enterpriseProducts(row) {
      this.$router.push({
        path: "/enterprise_products",
        query: {
          id: row.id,
        },
      });
    },
    async setHot(row){
      await this.$http.post('/admin/EnterpriseBusinessArea/setHot', {
        id: row.id,
        host:row.isHot==0?1:0
      });
      this.getlist()
    },
    async setConceal(row){
       await this.$http.post('/admin/EnterpriseBusinessArea/setStatus', {
         id: row.id,
         status:row.status==0?1:0
       });
      this.getlist()
    },
    edit(type,row) {
      var textTip=''
      if(type == 1) {
        textTip= `此操作将${row.isHot?'取消':'设置'}该国家热门, 是否继续?`
      }else {
        textTip= `此操作将${row.isHot?'取消':'设置'}隐藏该国家, 是否继续?`

      }
      this.$confirm(textTip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
           if(type==1){
             this.setHot(row)
           }else {
             this.setConceal(row)
           }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
    },
    addEnterprise(){
      this.$router.push({
        name: "enterprise_add",
      });
    },
    open(id) {
      this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$http.delete("/admin/Enterprise/delete", { params: { id: id } }).then((res) => {
              //   console.log(res)
              if (res.data.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                if (this.total % 10 == 1) {
                  this.currentPage--;
                }
                this.getlist();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },

    setTop(row, val) {
      // console.log(1)
      // console.log(row, id)
      this.$http
          .post("/admin/Enterprise/top", {
            id: row.id,
            top: val,
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.$message.success(res.message);
              this.getlist();
            } else {
              this.$message({
                message: res.message,
                type: "error",
                customClass: "zZindex",
              });
            }
            // this.btn1 = true
          });
    },
    show_qy(row) {
      this.p_a = true;
      this.p_a_f = row;
    },
    show(id, el) {
      this.$http.post("/admin/Enterprise/hide", { id: id, isHide: el }).then(({ data: res }) => {
        if (res.errorCode == 200) {
          this.$message.success(res.message);
          this.getlist();
        }
      });
    },
    chagne(row) {
      this.$http
          .post("/admin/UserSpeaker/editService", {
            id: row.id,
            waId: row.waId.join(","),
          })
          .then(({ data: res }) => {
            if (res.errorCode == 200) {
              this.getlist();
            } else {
              this.getlist();
            }
          });
    },
  },
};
</script>

<style lang="less" scoped>
.out {
  // width: 500px;

  margin-bottom: 20px;
  .input {
    width: 37%;
    display: inline-block;
    margin-right: 30px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.skyblue {
  color: skyblue;
}
.green {
  color: green;
}
.yellow {
  color: pink;
}
.red {
  color: red;
}
.out .input {
  width: 18%;
}
.el-card {
  position: relative;
}
.out .right {
  float: right;
}
.box {
  display: inline-block;
  margin: 5px;
}
</style>
